import axios from "axios";
import { getToken } from "./adminSession";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const asset = (p) => (p && p.startsWith("/static") ? `${BASE}/api${p}` : p);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const endpoints = {
  config: () => api.get("/config").then((r) => r.data),
  rooms: () => api.get("/rooms").then((r) => r.data),
  menu: () => api.get("/menu").then((r) => r.data),
  gallery: () => api.get("/gallery").then((r) => r.data),
  offers: () => api.get("/offers").then((r) => r.data),
  testimonials: () => api.get("/testimonials").then((r) => r.data),
  corporate: (d) => api.post("/corporate-enquiry", d).then((r) => r.data),
  preOrder: (d) => api.post("/pre-order", d).then((r) => r.data),
  login: (d) => api.post("/auth/login", d).then((r) => r.data),
  attractions: () => api.get("/attractions").then((r) => r.data),
  certifications: () => api.get("/certifications").then((r) => r.data),
};

export const CHAT_URL = `${API}/chat`;
